import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { trackEvent, EVENT_TYPE_PAGE } from '../utils/trackEvent.jsx';
import { fetchResourcePackage } from '../services/resourceLibraryAPI.js';
import LessonPlayer from '../components/resource-library/LessonPlayer.jsx';
import { PROFESSIONAL_DEVELOPMENT_PATH } from '../constants/professionalDevelopment.js';

function ResourceLesson() {
  const { slug } = useParams();
  const [resource, setResource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
  }, [slug]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setNotFound(false);
      try {
        const pkg = await fetchResourcePackage(slug);
        if (!cancelled) {
          if (pkg) setResource(pkg);
          else setNotFound(true);
        }
      } catch (e) {
        console.error(e);
        if (!cancelled) setNotFound(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-700" />
      </div>
    );
  }

  if (notFound || !resource) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-[#1a4a1a] mb-4">Resource not found</h1>
          <Link to={PROFESSIONAL_DEVELOPMENT_PATH} className="text-emerald-700 font-medium hover:underline">
            Back to Professional Development
          </Link>
        </div>
      </div>
    );
  }

  return <LessonPlayer resource={resource} />;
}

export default ResourceLesson;
